import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import { BankIDInputMeta, CorporateNameInputMeta } from "@Shared/containers/form/commonMeta";

export interface ICardCommissionFormMeta {
    bankId: FormInputMeta;
    bank: FormInputMeta;
    commissionID: FormInputMeta;
    commissionName: FormInputMeta;
    
    // Default
    ratio: FormInputMeta;
    fix: FormInputMeta;
    minimum: FormInputMeta;
    maximum: FormInputMeta;

    schema: any;
}

const cardCommissionFormMeta = {} as ICardCommissionFormMeta;

cardCommissionFormMeta.bankId = {...BankIDInputMeta, name: 'bankId'};

cardCommissionFormMeta.bank = {
  ...CorporateNameInputMeta,
  name: "bank",
  label: "Banque",
};

cardCommissionFormMeta.commissionID = {
  name: "commissionID",
  type: "text",
  label: "ID Commission",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

cardCommissionFormMeta.commissionName = {
  name: "commissionName",
  type: "text",
  label: "Nom Commission",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

cardCommissionFormMeta.ratio = {
  name: "ratio",
  type: "number",
  label: "Taux",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

cardCommissionFormMeta.fix = {
  name: "fix",
  type: "number",
  label: "Fixe",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

cardCommissionFormMeta.minimum = {
  name: "minimum",
  type: "number",
  label: "Minimum",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

cardCommissionFormMeta.maximum = {
  name: "maximum",
  type: "number",
  label: "Maximum",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};


cardCommissionFormMeta.schema = yup.object().shape(getValidationSchema(cardCommissionFormMeta));

export default cardCommissionFormMeta;